import { ValuesGroup } from '../model/values-group';
import { SetOfFilters } from '../filter/model/set-of-filters';

export function createValuesGroupForGeneralSetOfFilters(groupName: string, values: SetOfFilters[], allowDeleteValues: boolean): ValuesGroup<SetOfFilters> {
  return new ValuesGroup(groupName, values, allowDeleteValues, '#f3f3f3');
}

export function createValuesGroupForUserSetOfFilters(groupName: string, values: SetOfFilters[]): ValuesGroup<SetOfFilters> {
  return new ValuesGroup(groupName, values, true, '#ffffff');
}
